import React from 'react';

import PropTypes from 'prop-types';

import { errorChiku } from 'wanderu-assets';
import Helmet from 'wanderu-component-helmet';
import A from 'wanderu-component-react-router-link';
import {
    PageSection,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import locales from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './NotFound.scss';

function NotFound(props) {
    const {
        t,
        staticContext,
        status,
        message,
        title,
    } = props;

    const setStaticContext = () => {
        if (status === 401) {
            staticContext.status = 500;
            staticContext.cache = null;
            return;
        }

        if (status) {
            staticContext.status = status;
            return;
        }

        staticContext.status = 404;
    };

    if (staticContext) {
        setStaticContext();
    }

    return (
        <>
            <Helmet
                supportedLocales={locales.supportedLocales}
                noIndex
            />
            <PageSection layoutClassName={styles.content}>
                <img
                    alt=""
                    className={styles.chiku}
                    src={errorChiku}
                />
                <div className={styles.heading}>
                    {title || t('404-title')}
                </div>
                <p className={styles.messaging}>
                    {message || t('404-dont-worry', {
                        homepageLink: (
                            <A
                                href="/"
                                key="homepageLink"
                            >
                                {t('homepage')}
                            </A>
                        ),
                    })}
                </p>
            </PageSection>
        </>
    );
}

NotFound.propTypes = {
    staticContext: PropTypes.object,
    status: PropTypes.number,
    title: PropTypes.string,
    message: PropTypes.string,
};

NotFound.defaultProps = {
    staticContext: {},
    status: null,
    title: '',
    message: '',
};

export { NotFound };

export default localize(NotFound, ['t'], 'baseApp');
